import { ListAlt } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FilterBar, TableData } from 'components';
import { getAlertMonitorService, getAllAlertsService, getIntermittences } from 'services/admin/alertsService';
import { errorAlert } from 'helpers/alerts';
import { setCurrentIntermittence, setCurrentMonitor } from 'redux/slices/admin/alertSlice';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Image from 'components/common/Image';
import Images from 'assets/images';

const IntermittenceScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [types, setTypes] = useState(null)


  useEffect(() => {
    getAllAlertsService().then((result) => {
      setTypes(result)
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  // Una intermitencia puede haberse guardado sin transacciones asociadas, y eso ya no se
  // recupera: lo que se evita es mandar a nadie a una pantalla vacía.
  const tieneTxns = ({ txns }) => Array.isArray(txns) && txns.length > 0;

  const handlerTxns = (item) => {
    dispatch(setCurrentIntermittence(item));
    navigate('transacciones');
  }

  const handlerSubmit = (data) => {
    setLoading(true);
    data.page = page;
    data.limit = rowsPerPage;
    getIntermittences(data).then((response) => {
      setList(response.data);
      setTotal(response.total);
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }
  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        page={page}
        limit={rowsPerPage}
        showTitle={false}
        filters={[
          {
            name: "type",
            label: "Tipo",
            type: "select",
            multiple: true,
            data: types || [],
            loading: types == null,
            render: (value) => value.map((id) => {
              const type = types.find(o => o.id === id);
              return type?.name;
            }).join(', ')
          },
        ]}
      />
      <TableData
        dataRows={list}
        total={total}
        loading={loading}
        dataTitle={[
          "Alerta",
          "Tipo",
          "Instancia",
          "Inicio",
          "Fin",
          "Duración",
          "Transacciones"
        ]}
        onChangePage={page => setPage(page)}
        onChangeRowsPerPage={rowsPerPage => setRowsPerPage(rowsPerPage)}
        formatter={({ identification, alert, providerCredential, createdAt, end, txns }) => [
          identification,
          alert?.name,
          providerCredential?.name_connector || '-',
          moment(createdAt).format("DD/MM/YYYY HH:mm:ss"),
          end ? moment(end).format("DD/MM/YYYY HH:mm:ss") : '-',
          end && moment(end).diff(moment(createdAt), 'minutes') + ' min',
          tieneTxns({ txns }) ? txns.length : 'Sin transacciones'
        ]}
        actions={[
          {
            label: "Transacciones",
            icon: <Image src={Images.icon.actions} />,
            validate: tieneTxns,
            onClick: (data) => handlerTxns(data)
          },
        ]}
      />
    </>

  )
}

export default IntermittenceScreen